import { Twitter, Send, BarChart3, ArrowUpRight } from "lucide-react";
import Countdown from "@/components/Countdown";
import ContractAddress, { PUMP_FUN_URL, DEXSCREENER_URL } from "@/components/ContractAddress";

const SOCIALS = [
  {
    id: "twitter",
    label: "X / TWITTER",
    handle: "@LA28Army",
    sub: "Memes, raids & alpha drops",
    icon: Twitter,
    href: "https://x.com/LA28Army",
  },
  {
    id: "telegram",
    label: "TELEGRAM",
    handle: "t.me/la28army",
    sub: "Army HQ — 24/7 chat",
    icon: Send,
    href: "https://t.me/la28army",
  },
  {
    id: "dexscreener",
    label: "DEXSCREENER",
    handle: "$LA28 / SOL",
    sub: "Live chart & volume",
    icon: BarChart3,
    href: DEXSCREENER_URL,
  },
];

export default function Community() {
  return (
    <section
      id="community"
      data-testid="community-section"
      className="relative py-28 sm:py-36 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <div className="font-mono text-xs tracking-[0.32em] text-[#00F0FF] mb-5">
            // 04 · COMMUNITY
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[1] text-white">
            Join the <span className="text-[#00F0FF] glow-text">LA28 Army</span> chat.
          </h2>
          <p className="mt-6 text-white/65 max-w-xl mx-auto leading-relaxed">
            The army doesn’t wait. Lock in, meme harder, and ride the countdown.
            Every soldier matters.
          </p>
        </div>

        {/* Socials grid */}
        <div className="mt-14 grid sm:grid-cols-3 gap-5">
          {SOCIALS.map((s) => (
            <a
              key={s.id}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`community-link-${s.id}`}
              className="card-neon p-7 group block"
            >
              <div className="flex items-start justify-between">
                <div className="w-11 h-11 flex items-center justify-center border border-[#00F0FF]/40 bg-[#00F0FF]/5 text-[#00F0FF] group-hover:bg-[#00F0FF] group-hover:text-black transition-colors">
                  <s.icon className="w-5 h-5" />
                </div>
                <ArrowUpRight className="w-5 h-5 text-white/30 group-hover:text-[#00F0FF] transition-colors" />
              </div>
              <div className="mt-6 font-mono text-[10px] tracking-[0.32em] text-white/50">
                {s.label}
              </div>
              <div className="mt-2 font-heading text-xl font-bold text-white">
                {s.handle}
              </div>
              <p className="mt-1.5 text-sm text-white/55">{s.sub}</p>
            </a>
          ))}
        </div>

        {/* Mini countdown CTA */}
        <div className="mt-16 card-neon p-8 sm:p-12 text-center">
          <div className="font-mono text-[10px] tracking-[0.4em] text-white/50">
            // COUNTDOWN STILL TICKING
          </div>
          <div className="mt-6">
            <Countdown size="small" />
          </div>
          <div className="mt-8 flex flex-col sm:flex-row gap-4 items-center justify-center">
            <a
              data-testid="community-cta-join"
              href="#"
              className="btn-neon"
            >
              JOIN THE ARMY
            </a>
            <a
              data-testid="community-cta-buy"
              href={PUMP_FUN_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-neon btn-gold"
            >
              BUY ON PUMP.FUN
            </a>
          </div>

          <div className="mt-10 flex justify-center">
            <ContractAddress />
          </div>
        </div>
      </div>
    </section>
  );
}
